// Dynamic Diesels — Vehicle Finder + Garage.
// YMM submit is handled by dd-ymm-selection.js. This module manages the
// garage modal UI and syncs the sticky chip label with DdVehicleStorage.

(function () {
  'use strict';

  const YME_RESULTS_URL = '/pages/year-make-engine-search';
  const GARAGE_YMM_ROOT = '#dd-ymm-container-garage';

  function init() {
    const finder = document.querySelector('.dd-vf');
    const modal = document.querySelector('.dd-garage');
    if (!finder && !modal) return;

    document.querySelectorAll('[data-garage-open], [data-open-finder]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openModal();
      });
    });

    if (!modal) return;

    const listEl = modal.querySelector('[data-garage-list]');
    const emptyEl = modal.querySelector('[data-garage-empty]');

    modal.querySelectorAll('[data-garage-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    render();
    syncFinderChip();

    window.addEventListener('dd:vehicle-storage-change', () => {
      render();
      syncFinderChip();
    });

    function openModal() {
      window.DdYmmSelection?.initAll();
      render();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dd-garage-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dd-garage-open');
      document.body.style.overflow = '';
    }

    function populateGarageForm(vehicle) {
      window.DdYmmSelection?.initAll();
      if (vehicle) {
        window.DdYmmSelection?.populateRoot(GARAGE_YMM_ROOT, vehicle);
      } else {
        window.DdYmmSelection?.clearRoot(GARAGE_YMM_ROOT);
      }

      const makeSelect = document.querySelector(`${GARAGE_YMM_ROOT} [data-ymm-field="make"]`);
      if (makeSelect) makeSelect.focus();
    }

    function render() {
      if (!listEl) return;
      listEl.innerHTML = '';

      const vehicles = window.DdVehicleStorage?.getSavedVehicles() || [];
      const selected = window.DdVehicleStorage?.getSelectedVehicle();

      if (!vehicles.length) {
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;

      vehicles.forEach((vehicle) => listEl.appendChild(renderCard(vehicle, selected)));
    }

    function renderCard(vehicle, selected) {
      const card = document.createElement('div');
      const isActive = selected?.id === vehicle.id;
      card.className = 'dd-garage__card' + (isActive ? ' is-active' : '');
      card.dataset.id = vehicle.id;

      const displayName = formatVehicleLabel(vehicle);
      const activePill = isActive
        ? '<span class="dd-garage__card-active-pill">Active</span>'
        : '';

      card.innerHTML = `
        <div class="dd-garage__card-top">
          <div class="dd-garage__card-info">
            <div class="dd-garage__card-name">${escape(displayName)}</div>
          </div>
          ${activePill}
        </div>
        <div class="dd-garage__card-actions">
          <button type="button" class="dd-garage__card-btn dd-garage__card-btn--shop" data-action="shop">
            <iconify-icon icon="material-symbols:search" aria-hidden="true"></iconify-icon>
            Shop this truck
          </button>
          ${isActive ? '' : `<button type="button" class="dd-garage__card-btn" data-action="activate">Set active</button>`}
          <button type="button" class="dd-garage__card-btn" data-action="edit" aria-label="Edit vehicle">
            <iconify-icon icon="material-symbols:edit-outline" aria-hidden="true"></iconify-icon>
          </button>
          <button type="button" class="dd-garage__card-btn" data-action="delete" aria-label="Delete vehicle">
            <iconify-icon icon="material-symbols:delete-outline" aria-hidden="true"></iconify-icon>
          </button>
        </div>
      `;

      card.addEventListener('click', (e) => {
        const btn = e.target.closest('button[data-action]');
        if (!btn) return;
        e.stopPropagation();
        const action = btn.dataset.action;

        if (action === 'shop') {
          window.DdVehicleStorage?.selectVehicle(vehicle.id);
          window.location.href = YME_RESULTS_URL;
        } else if (action === 'activate') {
          window.DdVehicleStorage?.selectVehicle(vehicle.id);
          render();
          syncFinderChip();
        } else if (action === 'edit') {
          populateGarageForm(vehicle);
        } else if (action === 'delete') {
          window.DdVehicleStorage?.removeVehicle(vehicle.id);
          render();
          syncFinderChip();
        }
      });

      return card;
    }

    function syncFinderChip() {
      const selected = window.DdVehicleStorage?.getSelectedVehicle();
      const kicker = document.querySelector('[data-garage-kicker]');
      const title = document.querySelector('[data-garage-title]');

      if (selected?.make) {
        if (kicker) kicker.textContent = 'Your Truck';
        if (title) title.textContent = formatVehicleLabel(selected);
      } else {
        if (kicker) kicker.textContent = 'Your Garage';
        if (title) title.textContent = 'Find Your Truck';
      }
    }
  }

  function formatVehicleLabel(vehicle) {
    if (window.DdVehicleStorage?.formatVehicleDisplay) {
      return window.DdVehicleStorage.formatVehicleDisplay(vehicle);
    }
    return [vehicle?.year, vehicle?.make, vehicle?.engine].filter(Boolean).join(' ');
  }

  function escape(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
